"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoJsProviderStrategy = void 0;
var aes_1 = __importDefault(require("crypto-js/aes"));
var enc_utf8_1 = __importDefault(require("crypto-js/enc-utf8"));
var CryptoJsProviderStrategy = function () {
    var encrypt = function (plainText, key) {
        return aes_1.default.encrypt(plainText, key).toString();
    };
    var decrypt = function (cipherText, key) {
        return aes_1.default.decrypt(cipherText, key).toString(enc_utf8_1.default);
    };
    return {
        encrypt: encrypt,
        decrypt: decrypt,
    };
};
exports.CryptoJsProviderStrategy = CryptoJsProviderStrategy;
